import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchTrainingSchedules,
  deleteTrainingSchedule,
  updateTrainingSchedule,
} from "../../../../../store/trainingSchedulesSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CompleteTrainingDetail = ({ card, onClose }) => {
  const dispatch = useDispatch();
  const { schedules, loading, error } = useSelector((state) => state.trainingSchedules);

  const [filteredSchedules, setFilteredSchedules] = useState([]);
  const [editSchedule, setEditSchedule] = useState(null);
  const [editedValues, setEditedValues] = useState({
    scheduleStart: "",
    scheduleEnd: "",
    totalHours: "",
  });

  useEffect(() => {
    if (card?.id) {
      dispatch(fetchTrainingSchedules());
    }
  }, [dispatch, card]);

  useEffect(() => {
    if (card?.id) {
      const relatedSchedules = schedules.filter((schedule) => schedule.ictTC_id === card.id);
      setFilteredSchedules(relatedSchedules);
    }
  }, [schedules, card]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this schedule?")) {
      dispatch(deleteTrainingSchedule(id))
        .then(() => toast.success("Schedule deleted successfully!"))
        .catch(() => toast.error("Failed to delete the schedule."));
    }
  };

  const handleEdit = (schedule) => {
    setEditSchedule(schedule.id);
    setEditedValues({
      scheduleStart: schedule.scheduleStart,
      scheduleEnd: schedule.scheduleEnd,
      totalHours: schedule.totalHours,
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const start = new Date(editedValues.scheduleStart);
    const end = new Date(editedValues.scheduleEnd);
    const calculatedHours = Math.abs(end - start) / (1000 * 60 * 60);

    if (calculatedHours.toFixed(2) !== parseFloat(editedValues.totalHours).toFixed(2)) {
      toast.error(
        "The difference between Start and End time must match the Total Hours."
      );
      return;
    }

    dispatch(
      updateTrainingSchedule({
        id: editSchedule,
        scheduleStart: editedValues.scheduleStart,
        scheduleEnd: editedValues.scheduleEnd,
        totalHours: parseFloat(editedValues.totalHours),
        ictTC_id: card.id,
      })
    )
      .then(() => {
        toast.success("Schedule updated successfully!");
        setEditSchedule(null); // Close edit mode after success
      })
      .catch(() => toast.error("Failed to update the schedule."));
  };

  return (
    <div className="popup-overlay">
      <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="popup-content complete-card-Detail-pop">
        <h2>Schedule Details</h2>
        <button className="close-btn fa fa-close" onClick={onClose}></button>
        {loading ? (
          <p>Loading schedules...</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : filteredSchedules.length > 0 ? (
          <div className="schedule-list">
            <table className="schedule-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Start</th>
                  <th>End</th>
                  <th><i className="fa fa-clock"></i></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredSchedules.map((schedule, index) => (
                  <tr key={schedule.id}>
                    <td>{index + 1}</td>
                    {editSchedule === schedule.id ? (
                      <>
                        <td>
                          <input
                            type="datetime-local"
                            name="scheduleStart"
                            value={editedValues.scheduleStart}
                            onChange={handleEditChange}
                          />
                        </td>
                        <td>
                          <input
                            type="datetime-local"
                            name="scheduleEnd"
                            value={editedValues.scheduleEnd}
                            onChange={handleEditChange}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="totalHours"
                            value={editedValues.totalHours}
                            onChange={handleEditChange}
                            className="totalHours"
                          />
                        </td>
                        <td>
                          <i className="action-icon editIcon fa fa-plus-square" onClick={handleUpdate}>
                          </i>
                          <i
                            className="action-icon deleteIcon fa fa-close"
                            onClick={() => setEditSchedule(null)}
                          >
                          </i>
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{new Date(schedule.scheduleStart).toLocaleString()}</td>
                        <td>{new Date(schedule.scheduleEnd).toLocaleString()}</td>
                        <td>{schedule.totalHours}</td>
                        <td className="CTDButtons">
                          <i
                            className="action-icon fa fa-edit editIcon"
                            onClick={() => handleEdit(schedule)}
                          >
                          </i>
                          <i
                            className="action-icon fa fa-trash deleteIcon"
                            onClick={() => handleDelete(schedule.id)}
                          >
                          </i>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No schedules available for this training card.</p>
        )}
      </div>
    </div>
  );
};

export default CompleteTrainingDetail;
